import { ReactComponent as FootbalIcon } from "../../../../assets/utils/images/svgs/football-planscreen.svg";
import { ReactComponent as MessageIcon } from "../../../../assets/utils/images/svgs/Message.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/utils/images/svgs/search.svg";
import { ReactComponent as MinusIcon } from "../../../../assets/utils/images/svgs/minuspl.svg";
import { ReactComponent as LockedIcon} from "../../../../assets/utils/images/svgs/Lockedpl.svg";
import { ReactComponent as HelplIcon} from "../../../../assets/utils/images/svgs/Helppl.svg";
import { ReactComponent as CrossplIcon} from "../../../../assets/utils/images/svgs/Crosspl.svg";
import { ReactComponent as OkplIcon} from "../../../../assets/utils/images/svgs/Okpl.svg";
import { ReactComponent as StarIcon} from "../../../../assets/utils/images/svgs/staricon.svg";
import { ReactComponent as VVIcon} from "../../../../assets/utils/images/svgs/vvicon.svg";
import { ReactComponent as InformatIcon} from "../../../../assets/utils/images/svgs/inficon.svg";
import { ReactComponent as AAIcon} from "../../../../assets/utils/images/svgs/aaicon.svg";
import { ReactComponent as ActivepIcon} from "../../../../assets/utils/images/svgs/ActivePluspl.svg";


export const legend = [
	{
		label: "V",
		description: "Filter op geldigheid VOG",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "I",
		description: "Filter op geldigheid Identiteitsbewijs",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "P",
		description: "Filter op aanwezigheid Pabo-diploma",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "36",
		description: "Filter op basis van 36 maanden bewaking",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "Kr",
		description: "Filter op basis van ketenregeling",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "Br",
		description: "Filter op basis van blokkerdata",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: <FootbalIcon />,
		description: "Filter op gymbevoegdheid",
		state: ["enabled", "disabled"],
		border: true,
	},
	{
		label: "Mc",
		description: "Filter op matchcode",
		state: ["enabled", "disabled"],
		border: true,
	},

	{ label: "FV", description: "Filter functies volgens vervanger: Ja", state: ["+"], border: true },
	{ label: "FV", description: "Filter functies volgens vervanger: Nee", state: ["-"], border: true },
	{ label: "FV", description: "Filter functies volgens vervanger: Ja of Onbekend", state: ["+!"], border: true },
	{ label: "FV", description: "Filter functies volgens vervanger: Onbekend", state: ["!"], border: true },
	{ label: "FV", description: "Filter functies volgens vervanger: Uitgeschakeld", state: ["disabled"], border: true },

	{ label: "FB", description: "Filter functies volgens bestuur: Ja", state: ["+"], border: true },
	{ label: "FB", description: "Filter functies volgens bestuur: Nee", state: ["-"], border: true },
	{ label: "FB", description: "Filter functies volgens bestuur: Ja of Onbekend", state: ["+!"], border: true },
	{ label: "FB", description: "Filter functies volgens bestuur: Onbekend", state: ["!"], border: true },
	{ label: "FB", description: "Filter functies volgens bestuur: Uitgeschakeld", state: ["disabled"], border: true },

	{
		label: <strong>Con</strong>,
		description: (
			<div className="d-flex gap-1">
				<div>Continuïteit A/B,</div>
				<div>
					<div>
						<strong>A</strong> = Aantal inzetten van geselecteerde medewerker op deze school gedurende afgelopen 12 maanden
					</div>
					<div>
						<strong>B</strong> = Aantal keer dat de afwezige door deze medewerker is vervangen gedurende het lopende schooljaar
					</div>
				</div>
			</div>
		),
		state: [],
		border: false,
	},
	{
		label: <strong>KM</strong>,
		description: "Reisafstand school naar vervanger",
		state: [],
		border: false,
	},
	{
		label: <strong>Lft</strong>,
		description: "Leeftijd",
		state: [],
		border: false,
	},
	{
		label: <strong>S/V</strong>,
		description: (
			<div>
				<strong>S</strong> = Evaluatiescore door school, <strong>V</strong> = Evaluatiescore door vervanger
			</div>
		),
		state: [],
		border: false,
	},
	{
		label: <MessageIcon />,
		description: "Verstuur bulk-sms",
		state: ["enabled"],
		border: true,
	},
	{
		label: <SearchIcon />,
		description: "Filter geselecteerde vervangers",
		state: ["enabled"],
		border: true,
	},
	{
		label: <strong>% B</strong>,
		description: "Percentage beschikbare dagdelen in aanvraag",
		state: [],
		border: false,
	},
	{
		label: <strong>% E</strong>,
		description: "Percentage efficiëntie",
		state: [],
		border: false,
	},
	{
		label: <strong>Bs</strong>,
		description: "Beschikbaarheid",
		state: [],
		border: false,
	},
];



export const legendRight = [
	{ icon: <LockedIcon />, text: "Filter & controle: Uitgeschakeld voor dit criterium" },
	{ icon: <OkplIcon />, text: "Beschikbaar" },
	{ icon: <CrossplIcon />, text: "Niet beschikbaar" },
	{ icon: <HelplIcon />, text: "Beschikbaarheid onbekend" },
	{ icon: <AAIcon />, text: "Aangevraagd in ander verzoek" },
	{ icon: <VVIcon />, text: "Voorlopig ingepland in ander verzoek" },
	{ icon: <InformatIcon />, text: "Ingepland in ander verzoek" },
	{ icon: <StarIcon />, text: "Ingepland bij ander bestuur" }, 
	{ icon: <ActivepIcon />, text: "Contracttype tonen" },
	{ icon: <MinusIcon />, text: "Contracttype niet tonen" },
  ];

 